import { h } from 'preact';

export function IconLock({ width = 20, height = 20, fill = 'currentColor' }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 60 60"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ display: 'block' }}
      class="icon-lock"
    >
      <path
        d="M30 2.5C21.6908 2.5 15 9.19076 15 17.5V20C12.25 20 10 22.25 10 25V50C10 52.75 12.25 55 15 55H45C47.75 55 50 52.75 50 50V25C50 22.25 47.75 20 45 20V17.5C45 9.19076 38.3092 2.5 30 2.5ZM30 7.5C35.6908 7.5 40 11.8092 40 17.5V20H20V17.5C20 11.8092 24.3092 7.5 30 7.5ZM30 32.5C32.75 32.5 35 34.75 35 37.5C35 40.25 32.75 42.5 30 42.5C27.25 42.5 25 40.25 25 37.5C25 34.75 27.25 32.5 30 32.5Z"
        fill={fill}
      />
    </svg>
  );
}
